@if (viewPortService.viewPort$ | async; as viewPort) {
  <div
    [ngClass]="{
      details: true,
      'medium-screen': viewPort === 'medium',
      'large-screen': viewPort === 'large',
    }"
  >
    @if (order$ | async; as order) {
      @if (isProcessing$ | async; as isProcessing) {
        <div class="navigation">
          <md-icon-button (click)="goBack()" slot="trailing-icon">
            <md-icon>arrow_back</md-icon>
          </md-icon-button>
          <span> Back </span>
        </div>

        <div class="components-grid">
          @for (component of orderedComponents; track component.identifier) {
            @if (
              component.identifier === "detailed-summary" &&
              isDetailedSummaryEnabled
            ) {
              <div
                class="order-details-core component-item"
                data-identifier="detailed-summary"
              >
                <lib-scheduled-order-details
                  [order]="order"
                  [orderTotals$]="orderTotals$"
                  [orderVerboseName]="orderVerboseName"
                  [orderVerboseNamePlural]="orderVerboseNamePlural"
                  [nextOccurrenceVerboseName]="nextOccurrenceVerboseName"
                  [alignActionsToRight]="alignActionsToRight"
                  [useNextime]="
                    !deliveryService.isIgnored(order.id) &&
                    siteSettingsService.useNextime
                  "
                  [nextimeToken]="siteSettingsService.nextimeToken"
                  [nextimeSiteId]="siteSettingsService.nextimeSiteId"
                  [loadingTimeline]="deliveryService.isLoading"
                  [siteSettings]="siteSettingsService.siteSettings"
                  [closestNextOccurrenceDate]="closestNextOccurrenceDate"
                  [closestDeliveryDateUtc]="order.closestNextDeliveryDate"
                  (pause)="openDialog('pause-order', true)"
                  (cancel)="openDialog('cancel-order', true)"
                  (resume)="onResumeOrder($event)"
                  (processOrder)="onProcessOrder(order)"
                  (changeFrequency)="openDialog('change-frequency', false)"
                  (clickAddProducts)="openDialogAddProducts()"
                  (clickReschedule)="openDialog('reschedule-order', false)"
                  (rescheduleAndResume)="
                    openDialog('reschedule-order', true, { resumeAfter: true })
                  "
                  (rescheduleAndResumeDateInThePast)="
                    openDialog(
                      'reschedule-order',
                      true,
                      { resumeAfter: true },
                      order
                    )
                  "
                  (clickPaymentMethod)="openDialog('update-payment', true)"
                  (clickShippingAddress)="openDialog('shipping-address', true)"
                  (deliveryDateUpdate)="
                    deliveryService.onDeliveryDateUpdate($event, order)
                  "
                  (processNowDeliveryDateFetched)="
                    updateClosestDeliveryDate($event, order)
                  "
                />
              </div>
            }

            @if (
              component.identifier === "add-product" &&
              !order.bundleId &&
              isAddProductEnabled
            ) {
              <div
                class="order-details-products component-item"
                data-identifier="add-product"
              >
                <div class="products-header">
                  <span class="items-count">
                    @if (itemsCount$ | async; as itemsCount) {
                      ({{ itemsCount }})
                      {{ itemsCount === 1 ? "Item" : "Items" }}
                    }
                  </span>

                  <a
                    href="javascript:void(0);"
                    [ngClass]="{ disabled: isProcessing.value }"
                    (click)="
                      isProcessing.value ? null : openDialogAddProducts()
                    "
                  >
                    Add Product
                  </a>
                </div>

                @for (item of order.scheduledOrderItems; track item.id) {
                  <lib-scheduled-order-details-product
                    [orderItem]="item"
                    [orderVerboseName]="orderVerboseName"
                    [orderStatus]="order.status"
                    [siteSettings]="siteSettingsService.siteSettings"
                    (updateQuantity)="onUpdateQuantity($event, item)"
                    (deleteOrderItem)="onDeleteOrderItem($event)"
                    (editOrderItem)="onEditOrderItem(item)"
                    (changeQuantity)="onChangeQuantity($event)"
                  />

                  <div class="separator"></div>
                }

                <div class="products-actions">
                  <md-outlined-button
                    [disabled]="isProcessing.value"
                    (click)="
                      isProcessing.value ? null : openDialogAddProducts()
                    "
                  >
                    <span slot="icon" class="btn-icon material-symbols-outlined"
                      >add</span
                    >
                    Add Product
                  </md-outlined-button>
                </div>
              </div>
            }

            @if (
              component.identifier === "add-product" &&
              order.bundleId &&
              isAddProductEnabled
            ) {
              <div
                class="order-details-products component-item"
                data-identifier="add-product"
              >
                <lib-bundles-card
                  [bundle]="bundle"
                  [itemsCount]="(itemsCount$ | async)!"
                  [isProcessing]="isProcessing.value"
                  [order]="order"
                  [orderVerboseName]="orderVerboseName"
                  [siteSettings]="siteSettingsService.siteSettings"
                  [openDialogUpdateBundle]="openDialogUpdateBundle.bind(this)"
                  (updateQuantityEvent)="
                    onUpdateQuantity($event.event, $event.item)
                  "
                  (deleteOrderItemEvent)="onDeleteOrderItem($event)"
                  (editOrderItemEvent)="onEditOrderItem($event)"
                  (changeQuantityEvent)="onChangeQuantity($event)"
                />
              </div>
            }

            @if (
              component.identifier === "payment-method" &&
              isPaymentMethodEnabled
            ) {
              <div
                class="order-details-payment-method component-item"
                data-identifier="payment-method"
              >
                <div class="payment-method-header">
                  <span class="title">My Payment Methods</span>
                  <a
                    href="javascript:void(0);"
                    [ngClass]="{ disabled: isProcessing.value }"
                    (click)="
                      isProcessing.value
                        ? null
                        : openDialog('update-payment', true)
                    "
                  >
                    Update Payment
                  </a>
                </div>

                @if (order.paymentMethod) {
                  <div class="payment-method-content">
                    <lib-scheduled-order-payment-method
                      [orderStatus]="order.status"
                      [paymentMethod]="order.paymentMethod"
                      [NODDate]="order.nextOccurrenceUtc"
                      [scheduledOrderId]="order.id"
                      [currentPaymentMethod]="true"
                      [errorCode]="order.processingErrorCode"
                      (changePayment)="openDialog('update-payment', true)"
                      (resumeOrder)="onResumeOrder($event)"
                      (updateNextOccurrence)="updateNOD($event)"
                    />
                  </div>
                }
              </div>
            }

            @if (
              component.identifier === "shipping-delivery" &&
              isShippingDeliveryEnabled
            ) {
              <div
                class="order-details-shipping component-item"
                data-identifier="shipping-delivery"
              >
                <lib-scheduled-order-shipping
                  [order]="order"
                  [useNextime]="
                    !deliveryService.isIgnored(order.id) &&
                    siteSettingsService.useNextime
                  "
                  [isChangeShippingAddressEnabled]="
                    isChangeShippingAddressEnabled
                  "
                  [siteSettings]="siteSettingsService.siteSettings"
                  (changeShippingAddress)="openDialog('shipping-address', true)"
                  (changeDeliveryDate)="openDeliveryDateDialog()"
                />
              </div>
            }

            @if (component.identifier === "coupons") {
              @if (orderTotals$ | async; as orderTotals) {
                @if (showCoupons && isCouponsEnabled) {
                  @if (discounts$ | async; as discounts) {
                    <div
                      class="order-details-coupons component-item"
                      data-identifier="coupons"
                    >
                      <div class="coupons-header">
                        <span class="title">Coupons</span>
                        @if (isUpdateCouponsEnabled) {
                          <a
                            href="javascript:void(0);"
                            [ngClass]="{ disabled: isProcessing.value }"
                            (click)="
                              isProcessing.value
                                ? null
                                : openDialog('update-coupons', true, {
                                    discounts: discounts,
                                  })
                            "
                          >
                            Add Coupon
                          </a>
                        }
                      </div>

                      <div class="coupons-list">
                        @for (coupon of discounts; track coupon.entityId) {
                          <lib-scheduled-order-coupon
                            class="coupon"
                            [coupon]="coupon"
                            [orderVerboseName]="orderVerboseName"
                            (deleteCoupon)="onDeleteCoupon($event, order)"
                          />
                        }
                      </div>
                    </div>
                  }
                }
              }
            }

            @if (
              component.identifier === "order-totals-summary" &&
              isOrderTotalSummaryEnabled
            ) {
              @if (orderTotals$ | async; as orderTotals) {
                <div
                  class="order-details-summary component-item"
                  data-identifier="order-totals-summary"
                  [ngStyle]="[hideNotesComponent ? 'margin-bottom: 0' : '']"
                >
                  <lib-scheduled-order-summary
                    [order]="order"
                    [orderTotals]="orderTotals"
                    [orderVerboseName]="orderVerboseName"
                    [useNextime]="
                      !deliveryService.isIgnored(order.id) &&
                      siteSettingsService.useNextime
                    "
                    [siteSettings]="siteSettingsService.siteSettings"
                    (clickCoupon)="openDialog('update-coupons', true)"
                    (clickShipping)="openDialog('shipping-address', true)"
                    (clickPayment)="openDialog('update-payment', true)"
                  />
                </div>
              }
            }

            @if (
              component.identifier === "order-notes" &&
              !hideNotesComponent &&
              isOrderNotesEnabled
            ) {
              @if (orderTotals$ | async; as orderTotals) {
                <div
                  class="order-details-note component-item"
                  data-identifier="order-notes"
                  [ngStyle]="[!hideNotesComponent ? 'margin-bottom: 0' : '']"
                >
                  <lib-add-note
                    [order]="order"
                    [canUpdateNotes]="siteSettingsService.canUpdateNotes"
                  />
                </div>
              }
            }
          }
        </div>
      }
    }
  </div>
}
